/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Lots_Col_AvailableInputs */

const vi_pl_lots_col_available = /** @type {(inputs: Pl_Lots_Col_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn`)
};

/**

* @param {Pl_Lots_Col_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_lots_col_available = /** @type {((inputs?: Pl_Lots_Col_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Lots_Col_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_lots_col_available(inputs)
});